import { useState } from 'react';
import { INITIAL_BOT_CONFIGS } from '../constants/trainingConstants';

export function useTrainingState() {
  const [currentStep, setCurrentStep] = useState(1);
  const [dragActive, setDragActive] = useState(false);

  // File upload and extraction states
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [extractedContents, setExtractedContents] = useState([]); // Store extracted content
  const [processingFiles, setProcessingFiles] = useState(false);
  const [processingError, setProcessingError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(0);
  const [additionalText, setAdditionalText] = useState('');
  const [combinedContent, setCombinedContent] = useState(''); // Combined content for processing

  // Storyboard/Team Setup states
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedMoment, setSelectedMoment] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [isTechnicalMode, setIsTechnicalMode] = useState(false);

  // Select Assets states
  const [loadedAssets, setLoadedAssets] = useState([]);
  const [assetViewMode, setAssetViewMode] = useState('all');
  const [requiredAssets, setRequiredAssets] = useState([]);
  const [manualEntryText, setManualEntryText] = useState('');
  const [dragActiveAssets, setDragActiveAssets] = useState(false);
  const [analyzingAssets, setAnalyzingAssets] = useState(false);
  const [analyzedAssets, setAnalyzedAssets] = useState([]); // Assets analyzed from documents
  const [expandedAssetId, setExpandedAssetId] = useState(null); // For editing asset info

  // Bot Configuration states
  const [expandedBots, setExpandedBots] = useState({});
  const [botConfigs, setBotConfigs] = useState(INITIAL_BOT_CONFIGS);

  // Storyboard data structure
  const [chapters, setChapters] = useState([]);
  const [generatingStoryboard, setGeneratingStoryboard] = useState(false);

  // Ollama connection state
  const [ollamaConnected, setOllamaConnected] = useState(null);

  return {
    // Step navigation
    currentStep,
    setCurrentStep,

    // Upload step
    dragActive,
    setDragActive,
    uploadedFiles,
    setUploadedFiles,
    extractedContents,
    setExtractedContents,
    processingFiles,
    setProcessingFiles,
    processingError,
    setProcessingError,
    selectedFile,
    setSelectedFile,
    additionalText,
    setAdditionalText,
    combinedContent,
    setCombinedContent,

    // Review step
    // (uses uploadedFiles, extractedContents, and selectedFile)

    // Team setup step
    expandedBots,
    setExpandedBots,
    botConfigs,
    setBotConfigs,

    // Asset selection step
    loadedAssets,
    setLoadedAssets,
    assetViewMode,
    setAssetViewMode,
    requiredAssets,
    setRequiredAssets,
    manualEntryText,
    setManualEntryText,
    dragActiveAssets,
    setDragActiveAssets,
    analyzingAssets,
    setAnalyzingAssets,
    analyzedAssets,
    setAnalyzedAssets,
    expandedAssetId,
    setExpandedAssetId,

    // Storyboard step
    searchQuery,
    setSearchQuery,
    selectedMoment,
    setSelectedMoment,
    activeTab,
    setActiveTab,
    isTechnicalMode,
    setIsTechnicalMode,
    chapters,
    setChapters,
    generatingStoryboard,
    setGeneratingStoryboard,

    // Ollama connection
    ollamaConnected,
    setOllamaConnected,
  };
}
